/* Keep breeder links available after routine strain-page refreshes. */
(() => {
  const registry = window.CS_BREEDER_REGISTRY;
  if (!Array.isArray(registry) || !registry.length) return;
  const language = (document.documentElement.lang || 'de').split('-')[0];
  const prefix = ['en', 'es'].includes(language) ? `/${language}` : '';
  const names = new Map();
  registry.forEach(breeder => [breeder.name, ...(breeder.aliases || [])].forEach(name => names.set(name, breeder.slug)));
  const escaped = [...names.keys()].sort((a,b) => b.length - a.length).map(name => name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const pattern = new RegExp(`(?<![\\p{L}\\p{N}_])(?:${escaped.join('|')})(?![\\p{L}\\p{N}_])`, 'gu');
  const label = /^(?:Breeders?|Züchter|Criador(?:es)?)\s*:?$/i;
  const values = new Set();
  document.querySelectorAll('.cs-growlab-page dt').forEach(dt => { if (label.test(dt.textContent.trim()) && dt.nextElementSibling?.tagName === 'DD') values.add(dt.nextElementSibling); });
  document.querySelectorAll('.cs-growlab-metric').forEach(article => { if (label.test(article.querySelector('span')?.textContent.trim() || '')) { const value = article.querySelector('strong'); if (value) values.add(value); } });
  document.querySelectorAll('.cs-growlab-page p > strong:first-child').forEach(strong => { if (label.test(strong.textContent.trim())) values.add(strong.parentElement); });
  values.forEach(value => {
    const walker = document.createTreeWalker(value, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) if (!walker.currentNode.parentElement.closest('a,script,style')) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      const matches = [...node.textContent.matchAll(pattern)];
      if (!matches.length) return;
      const fragment = document.createDocumentFragment();
      let offset = 0;
      matches.forEach(match => {
        fragment.append(document.createTextNode(node.textContent.slice(offset, match.index)));
        const link = document.createElement('a');
        link.href = `${prefix}/pages/breeder-${names.get(match[0])}`;
        link.dataset.csBreeder = names.get(match[0]);
        link.textContent = match[0];
        fragment.append(link);
        offset = match.index + match[0].length;
      });
      fragment.append(document.createTextNode(node.textContent.slice(offset)));
      node.replaceWith(fragment);
    });
    value.querySelectorAll('a[data-cs-breeder]').forEach(link => { link.href = `${prefix}/pages/breeder-${link.dataset.csBreeder}`; });
  });
  const navigation = document.querySelector('.cs-growlab-hub__nav');
  if (navigation && !navigation.querySelector('[data-cs-breeder-directory-link]')) {
    const link = document.createElement('a');
    link.href = `${prefix}/pages/breeder`;
    link.dataset.csBreederDirectoryLink = '';
    link.textContent = language === 'es' ? 'Criadores' : language === 'en' ? 'Breeders' : 'Breeder';
    navigation.append(link);
  }
})();
